// extracted by mini-css-extract-plugin
module.exports = {"dealsModalContent":"az_tPb","headerSection":"az_uPb","productTagImg":"az_vPb","verticalBar":"az_wPb","prodDescPopup":"az_xPb","mainProduct":"az_yPb","gridView":"az_zPb"};